import { render, staticRenderFns } from "./editproduct.vue?vue&type=template&id=ea1fc428&scoped=true&"
import script from "./editproduct.vue?vue&type=script&lang=js&"
export * from "./editproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1fc428",
  null
  
)

export default component.exports